import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Copy from 'components/copy'
import { Wrapper, Row, CopyWrapper, Image } from './index.styled'
import ImageWrapper from 'components/ui/image-wrapper'
const Info = ({ data }) => {
  const { images, contentInfo, anchorID } = data
  return (
    <Wrapper id={anchorID}>
      <Row>
        <Image>
          <ImageWrapper>
            <GatsbyImage
              className="building-image"
              image={getImage(images[0]?.file)}
              alt=""
            />
          </ImageWrapper>
        </Image>
        <CopyWrapper>
          <Copy data={contentInfo[0]} />
        </CopyWrapper>
      </Row>
    </Wrapper>
  )
}

export default Info
